import React from 'react'

import { colors } from '../../constants/theme'

const SocialFb = ({ background = colors.black }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M11.9994 0.00332903L9.92456 0C7.59358 0 6.08719 1.5455 6.08719 3.93758V5.75307H4.00105C3.82078 5.75307 3.6748 5.89921 3.6748 6.07948V8.70992C3.6748 8.89018 3.82095 9.03616 4.00105 9.03616H6.08719V15.6736C6.08719 15.8539 6.23317 15.9998 6.41343 15.9998H9.13525C9.31552 15.9998 9.4615 15.8537 9.4615 15.6736V9.03616H11.9007C12.0809 9.03616 12.2269 8.89018 12.2269 8.70992L12.2279 6.07948C12.2279 5.99293 12.1935 5.91003 12.1324 5.84878C12.0713 5.78752 11.9881 5.75307 11.9015 5.75307H9.4615V4.21406C9.4615 3.47435 9.63777 3.09883 10.6014 3.09883L11.9991 3.09833C12.1792 3.09833 12.3251 2.95219 12.3251 2.77209V0.329574C12.3251 0.14964 12.1793 0.00366194 11.9994 0.00332903Z"
        fill={background}
      />
    </g>
  </svg>
)

export default SocialFb
